import styled from 'styled-components'

const Button = styled.button`
  width: 38px;
  height: 38px;
  border: ${(p) => `solid ${p.theme.uiKit.colors.global.grey.grey100} ${p.theme.uiKit.borderWidth.strokeS};`};
  background-color: ${(p) => p.theme.uiKit.colors.global.grey.grey100};
  color: ${(p) => p.theme.uiKit.colors.global.grey.grey700};
  border-radius: 3px;
  cursor: pointer;

  transition:
    background 0.15s,
    color 0.15s,
    outline 0.15s,
    box-shadow 0.15s,
    border-color 0.15s;

  svg {
    transition:
      fill 0.15s,
      color 0.15s;
  }

  &:hover {
    border: ${(p) => `solid ${p.theme.uiKit.colors.global.grey.grey500} ${p.theme.uiKit.borderWidth.strokeS};`};
    background-color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
    color: ${(p) => p.theme.uiKit.colors.global.general.main};
  }

  &:active {
    border: ${(p) => `solid ${p.theme.uiKit.colors.global.grey.grey700} ${p.theme.uiKit.borderWidth.strokeS};`};
    background-color: ${(p) => p.theme.uiKit.colors.global.grey.grey700};
    color: ${(p) => p.theme.uiKit.colors.global.general.main};
  }

  &:focus {
    border: ${(p) => `solid ${p.theme.uiKit.colors.global.grey.grey700} ${p.theme.uiKit.borderWidth.strokeM};`};
    background-color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
    color: ${(p) => p.theme.uiKit.colors.global.general.main};
  }

  &:disabled {
    border: ${(p) => `solid ${p.theme.uiKit.colors.global.grey.grey300} ${p.theme.uiKit.borderWidth.strokeM};`};
    background-color: ${(p) => p.theme.uiKit.colors.global.grey.grey300};
    color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
    cursor: default;
  }
`

export const s = { Button }
